<template>
  <b-row>
    <b-col sm="12">
      <b-card header="Listado de Ordenes de Trabajo">
        <div class="table-responsive">
          <div class="form-group form-inline pull-left">
            <input
              v-model="search"
              type="search"
              class="form-control"
              placeholder="Buscar Orden de Trabajo"
            /> &nbsp;
          </div>
          <table class="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Placa</th>
                <th v-if="!isPrev">Conductor</th>
                <th>Mecánico</th>
                <th v-if="isPrev">Tipo</th>
                <th>Fecha inicio</th>
                <th>Fecha Fin</th>
                <th>Estado</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ot, k) in paginated('filteredOts')" :key="k">
                <td>{{ot.incident ? ot.incident.truck.plate : ot.truck.plate }}</td>
                <td v-if="!isPrev">{{ot.incident.driver.name}} {{ot.incident.driver.last_name}}</td>
                <td>{{ot.mech ? ot.mech.name : '-'}}</td>
                <td v-if="isPrev">Tipo {{ot.plan.type.name}}: {{ot.plan.type.description}}</td>
                <td>{{ot.initial_date | formatDate}}</td>
                <td>{{ot.final_date | formatDate}}</td>
                <td>{{ot.status.name}}</td>
                <td>
                  <b-button
                    v-if="!isPrev"
                    @click="openDetail(ot)"
                    type="button"
                    variant="primary"
                  >Ver Detalle</b-button>&nbsp;
                  <b-button
                    v-if="isPlanner && !ot.approved"
                    @click="approve(ot)"
                    type="button"
                    variant="primary"
                  >Aprobar</b-button>&nbsp;
                  <b-button
                    v-if="isEditable(ot)"
                    @click="goEdit(ot.id)"
                    type="button"
                    variant="primary"
                  >Editar</b-button>
                </td>
              </tr>
            </tbody>
          </table>
          <paginate name="filteredOts" :list="filteredOts" class="paginate-list" :per="10"></paginate>
          <paginate-links
            for="filteredOts"
            :limit="5"
            :show-step-links="true"
            :step-links="{
                next: '>>',
                prev: '<<'
              }"
            :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
          ></paginate-links>
          <DetailModal :showModal="showModal" :ot="selectedOt" @close="showModal = false" />
          <div v-if="showModal" class="modal-backdrop fade show"></div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import { mapGetters } from "vuex";
import DetailModal from "./DetailModal";

export default {
  components: { DetailModal },
  data() {
    return {
      ots: [],
      paginate: ["filteredOts"],
      search: "",
      constants,
      isPlanner: false,
      approvedStatus: {},
      type: constants.PREVENTIVA,
      isPrev: true,
      selectedOt: {},
      showModal: false
    };
  },
  mounted() {
    this.type = this.$route.params.type;
    this.isPrev = this.type === constants.PREVENTIVA;
    api.get(`/work_orders/${this.type}`).then(response => {
      this.ots = response.ots;
    });
    api.get("/work_order_statuses/1").then(response => {
      this.approvedStatus = response.statuses.find(
        st => st.code === constants.MANT_APROBADO
      );
    });
    this.isPlanner =
      this.user.role.code === constants.PLANIFICADOR_MANTENIMIENTO;
  },
  methods: {
    isEditable(ot) {
      const { isPlanner } = this;
      const isFinished = ot.status.code === constants.MANT_FINALIZADO;
      if (!isFinished) return (!isPlanner && ot.approved) || isPlanner;
      return false;
    },
    openDetail(ot) {
      this.selectedOt = ot;
      this.showModal = true;
    },
    approve(ot) {
      const { approvedStatus } = this;
      api
        .put(`/work_order/${ot.id}`, {
          approved: true,
          status_id: approvedStatus.id
        })
        .then(response => {
          this.$socket.emit("updateWorkOrderServer", response.ot);
          // const index = this.ots.findIndex(r => r.id === ot.id);
          // if (index >= 0) {
          //   this.ots.splice(index, 1, {
          //     ...ot,
          //     approved: true,
          //     status: approvedStatus
          //   });
          // }
        });
    },
    newOt() {},
    goEdit(id) {
      this.$router.push({
        path: `/fleet/maintenance/edit/${id}`
      });
    }
  },
  computed: {
    ...mapGetters({ user: "user/user" }),
    filteredOts() {
      return this.ots.filter(ot => {
        return this.search
          ? ot.incident.truck.plate
              .toLowerCase()
              .includes(this.search.toLowerCase())
          : true;
      });
    }
  },
  sockets: {
    connect: function() {
      console.log("socket connected");
    },
    updateWorkOrder: function(ot) {
      const index = this.ots.findIndex(r => r.id === ot.id);
      if (index >= 0) this.ots.splice(index, 1, ot);
    },
    newWordOrder: function(ot) {
      this.ots.unshift(ot);
    }
  }
};
</script>
